module.exports = __webpack_public_path__ + "media/images/pg-top/exp-fund-seminar-2307-1e8b762efafd06e910beb45cc1a5a710.jpg";